import React from "react";
import ReactCrop from "react-image-crop";
import Modal from "react-bulma-components/lib/components/modal";
import "react-image-crop/dist/ReactCrop.css";
import Button from "react-bulma-components/lib/components/button";
import "../../../styles/uploadimage.css";
import "../../../styles/myProfile.css";
import {inject, observer} from "mobx-react";
import {Redirect, withRouter} from "react-router-dom";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import ReactGA from "react-ga";
// import Tag from 'react-bulma-components/lib/components/tag';
import {base64StringtoFile, extractImageFileExtensionFromBase64, image64toCanvasRef} from "../../../helpers/reusable";
import {
    validateIfInputHasCharactersAllowSpaces,
    validateIfInputHasEmail,
    validateIfInputHasTenDigits,
    validateInputLength
} from "../../../helpers/validationChecks";
// import restler from 'restler'
import resizer from "image-resizer-js";
import "bootstrap/dist/css/bootstrap.min.css";
import Agent from '../../../api/agent'

var qs = require('qs')
const imagespath = {
    bigPlus: require('../../../assets/Big_plus_svg.svg'),
    deleteIcon: require('../../../assets/delete_icon_svg.svg')
}
const uploadedArtIconBig = require('../../../assets/verified_svg.svg')




const MAX_IMAGES = 3;
const getInitialState = () => ({
    imageCropped: false,
    showCropMode: false,
    cropDetails: {},
    modifiedImages: [],
    modifiedImagesThumbnail: [],
    finalImages: [],
    currencyExchangerates: {},
    selectedOriginalImageUrl: '',
    selectedOriginalImage: null,
    selectedFile: null,
    preview: "none",
    submittedImages: false,
    browse: "visible",
    currencySelected: '',
    selectedCustomMedium: false,
    selectedCustomBase: false,
    customBaseQuery: "",
    customMediumQuery: "",
    editMode: false,
    artwork_id: false,
    dimension: 0,
    artworkInfo: {
        title: "",
        private_mode: false,
        description: "",
        tags: "",
        seller_price: 0,
        dimension: 0,
        young_artist: false,
        product_base_price: 0,
        height: 0,
        width: 0,
        depth: 0,
        base_height: 0,
        base_width: 0,
        base_depth: 0,
        year: 0,
        disability: false,
        mature_content: false,
        sell_prints: false,
        usd_price: 0,
        self_created: false,
        currency_code: localStorage.getItem("preferred_currency"),
        medium: "",
        base: "",
        created_by: "",
        print_price: "",
        wish_to_sell: false,
        custom_base: "",
        custom_medium: "",

    }
})

const year = (new Date()).getFullYear();
const years = Array.from(new Array(2000), (val, index) => -index + year);

@inject('userStore', 'generalStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'likeAndUnlikeStore')
@withRouter
@observer
export default class uploadImage extends React.Component {
    constructor() {
        super();
        this.imagePreviewCanvasRef = React.createRef()
        // this.state = initialState();
        this.state = getInitialState();
    }


    componentDidMount() {
        ReactGA.pageview('/upload_artwork_screen');
        if (localStorage.hasOwnProperty("userData")) {
            Agent.generalData.listOfMediums()
                .then((res) => {
                    var MediumChoices = [];
                    // console.log("list of mediums", res)
                    res.data.data.forEach((el, idx) => {
                        MediumChoices.push({
                            "label": el.material,
                            "value": el.material
                        })
                    })
                    // console.log("medium choices look like this", MediumChoices)
                    // this.props.generalStore.setMediumAndBaseChoices(MediumChoices)
                    this.setState({
                        mediumChoices: MediumChoices
                    })
                }

                );
            Agent.generalData.listOfBases()
                .then((res) => {
                    // console.log("list of mediums", res)
                    var BaseChoices = [];
                    // console.log("list of mediums", res)
                    res.data.data.forEach((el, idx) => {
                        BaseChoices.push({
                            "label": el.material,
                            "value": el.material
                        })

                        this.setState({
                            baseChoices: BaseChoices
                        })
                    })
                }

                )
        }
        if (this.props.match.params.artwork_id) {
            ReactGA.pageview('/Edit artwork screen');
            let str = this.props.match.params.artwork_id

                // console.log("[this is artwork id for details]", str)
                this.setState({
                    editMode: true,
                    artwork_id: str,
                    medium: "",
                    artworkMedium: [
                        { label: 'Oil', value: "Oil" },
                        { label: 'Acrylic', value: "Acrylic" },
                        { label: 'Others', value: "Others" },
                    ]


                },
                )
                this.props.artworksStore.getArtworkDetailsPrivate(str)
                    .then((response) => {
                        // console.log(response)
                        var mediumOptions = []
                            // var mediumArray = response.data[0].medium.replace(", ", ",")
                            // var mediumArray = response.data[0].medium.replace(" ,", ",")
                        mediumArray = response.data[0].medium.split(", ")
                        mediumArray.forEach((el) => mediumOptions.push({ label: el, value: el }))
                        // console.log("I am creating this shit", mediumOptions, response.data[0].medium)
                        // console.log("I am creating this shit", mediumOptions)
                        // // console.log("I am creating this shit", this.state.artworkMedium)
                        var baseOptions = []
                        var mediumArray = response.data[0].base.split(", ")
                        mediumArray.forEach((el) => baseOptions.push({ label: el, value: el }))
                        // console.log("I am creating this shit", baseOptions)
                        this.setState({
                            medium: mediumOptions || response.data[0].medium,
                            base: baseOptions || response.data[0].base,
                            selectedCustomMedium: response.data[0].medium.includes("Others"),
                            selectedCustomBase: response.data[0].base.includes("Others"),

                            artworkInfo: {
                                ...this.state.artworkInfo,
                                title: response.data[0].title,
                                description: response.data[0].description,
                                story: response.data[0].story,
                                tags: response.data[0].tags,
                                seller_price: response.data[0].seller_price,
                                young_artist: response.data[0].young_artist,
                                product_base_price: response.data[0].product_base_price,
                                // dimension: response.data[0].dimension,
                                height: response.data[0].height,
                                width: response.data[0].width,
                                depth: response.data[0].depth,
                                base_height: response.data[0].base_height,
                                base_width: response.data[0].base_width,
                                base_depth: response.data[0].base_depth,
                                year: response.data[0].year,
                                disability: response.data[0].disability,
                                mature_content: response.data[0].mature_content,
                                sell_prints: response.data[0].sell_prints,
                                usd_price: response.data[0].usd_price,
                                self_created: response.data[0].self_created,
                                currency_code: response.data[0].currency_code || localStorage.getItem("preferred_currency"),
                                medium: response.data[0].medium,
                                custom_medium: response.data[0].custom_medium,
                                custom_base: response.data[0].custom_base,
                                base: response.data[0].base,
                                created_by: response.data[0].created_by,
                                print_price: response.data[0].print_price,
                                wish_to_sell: response.data[0].wish_to_sell,
                                artworkImg1: response.data[0].img1,
                                artworkImg2: response.data[0].img2,
                                artworkImg3: response.data[0].img3,
                                dimension: response.data[0].dimension,
                            }
                        })
                    })
            };

            this.props.generalStore.getAllCurrenciesExchangeRate()
                .then((res) => {
                    // console.log(res)
                    this.setState({
                        currencyExchangerates: res.data
                    }, function () {
                        // console.log(this.state.currencyExchangerates)
                    })
                })
        }

        onCloseCrop() {
            this.setState({ showCropMode: false });
        }

        handleInputTextChange(event) {
            this.setState({ artworkInfo: { ...this.state.artworkInfo, [event.target.name]: event.target.value } }, () => {
                // console.log("changed the input box ", this.state.artworkInfo);
            })
        }

        close() {
            this.setState({
                submittedImages: false
            }, () => {
                this.props.history.replace(`/profile/details/${localStorage.getItem("username")}`)
            })
        }
        showImage(event) {
            // console.log("[showImage] ", event.target.name);
            // let reader = new FileReader();
            var currentFile = event.target.files[0];
            var originalImageUrl = URL.createObjectURL(currentFile);
            this.setState({
                showCropMode: true,
                selectedOriginalImage: currentFile,
                selectedOriginalImageUrl: originalImageUrl,
            })
        }

        handleOnCropChange = (cropDetails) => {
            this.setState({ cropDetails })
        }
        handleOnCropComplete = (crop, pixelCrop) => {
            // console.log("[crop complete]", pixelCrop);

            const canvasRef = this.imagePreviewCanvasRef.current
            image64toCanvasRef(canvasRef, this.state.selectedOriginalImageUrl, pixelCrop);
            // croppedImage
            // const imageData64 = canvasRef.toDataURL('image/' + extractImageFileExtensionFromBase64(this.state.selectedOriginalImage))
            // const croppedImage = base64StringtoFile(imageData64, 'unnamed_file');
            // const croppedImageUrl = URL.createObjectURL(croppedImage)
            this.setState({
                //pixelCropState: pixelCrop,
                imageCropped: true,
                // selectedCroppedImage: croppedImage,
                // selectedCroppedImageUrl: croppedImageUrl,
            })
        }
        // handleCurrencySelection(currencyAbbrevation) {
        //     // console.log(`Selected ${currencyAbbrevation}`)
        //     this.setState({
        //         artworkInfo: { ...this.state.artworkInfo, currency_code: currencyAbbrevation }
        //     }, function () {
        //         // console.log(this.state.artworkInfo)
        //     })
        // }
        handleDimensionChange(dimension) {
            // console.log(dimension)
            this.setState({

                artworkInfo: {
                    ...this.state.artworkInfo,
                    dimension: dimension.target.value
                }
            }, function () {
                // console.log(this.state.dimension)
            })
        }

        handleInputTextChangeGeneral(event) {
            this.setState({
                [event.target.name]: event.target.value
            })
        }
        handleImageLoaded = (image) => {
            // // console.log("asdfghj", image);
            // // console.log("asdfghjasd", image.src);
            this.setState({
                // selectedOriginalImage: image
            })
        }

        onImageCropDone() {
            this.setState({
                preview: ""
            })
            const scope = this;
            scope.onCloseCrop();
            const canvasRef = this.imagePreviewCanvasRef.current
            // console.log("this.state.selectedOriginalImageUrlthis.state.selectedOriginalImageUrl", this.state.selectedOriginalImageUrl)
            const imageData64 = canvasRef.toDataURL('image/' + extractImageFileExtensionFromBase64(this.state.selectedOriginalImageUrl))
            // const myFilename = this.state.file 
            if ((imageData64) <= 5) {
                var image = new Image();
                // console.log("chbdhbvjdfvbfjv bfhv hf vhfv hfv ", imageData64)
                image.src = scope.state.selectedOriginalImageUrl;
                image.onload = () => {
                    var height = image.height;
                    var width = image.width;
                    scope.setState({
                        selectedCroppedImage: scope.state.selectedOriginalImage,
                        selectedCroppedImageUrl: scope.state.selectedOriginalImageUrl,
                    }, () => {
                        scope.validateImageDimensions(height, width);
                    });
                }
            }
            else {
                const myNewCroppedFile = base64StringtoFile(imageData64, "unnamed_file_2.png");
                // // console.log("myNewCroppedFilenm", this.state.imageCropped, myNewCroppedFile);
                const imageUrl = URL.createObjectURL(myNewCroppedFile)
                // // console.log("FileUrl", myNewCroppedFile.name)
                // // console.log(this.state.crop)
                if (this.state.imageCropped) {
                    // Initiate the JavaScript Image object.
                    var image = new Image();
                    // Set the Base64 string return from FileReader as source.
                    image.src = imageUrl;
                    image.onload = () => {
                        var height = image.height;
                        var width = image.width;
                        // // console.log("cropped dimensions", height, width)
                        scope.setState({
                            selectedCroppedImage: myNewCroppedFile,
                            selectedCroppedImageUrl: imageUrl,
                            cropDetails: {},
                            imageCropped: false
                        }, () => {
                            scope.validateImageDimensions(height, width);
                        })
                    }
                }
                else {
                    var image = new Image();
                    image.src = scope.state.selectedOriginalImageUrl;
                    image.onload = () => {
                        var height = image.height;
                        var width = image.width;
                        scope.setState({
                            selectedCroppedImage: scope.state.selectedOriginalImage,
                            selectedCroppedImageUrl: scope.state.selectedOriginalImageUrl,
                        }, () => {
                            scope.validateImageDimensions(height, width);
                        });
                    }
                }
            }
        }

        validateImageDimensions(height, width) {
            // console.log("selectedCroppedImage", this.state.selectedCroppedImage)
            // console.log("[validateImageDimensions] image dimensions", height, width)
            if ((height >= width && height < 520) || (width >= height && width < 520)) {
                this.props.navigatorStore.openErrorModal("Please upload picture of size greater than 520x520 px");
                this.onImageReject();
                return;
            }
            let newHeight = height;
            let newWidth = width;
            if (width >= height && width > 1500) {
                newWidth = 1500
                newHeight = (height / width) * newWidth;
            }
            else if (height >= width && height > 1500) {
                newHeight = 1500
                newWidth = (width / height) * newHeight;
            }
            this.onImageAccept(newHeight, newWidth);
        }

        onImageAccept(newHeight, newWidth) {
            // console.log("[onImageAccept]", newHeight, newWidth)
            this.setState({
                modifiedImages: this.state.modifiedImages.concat({
                    url: this.state.selectedCroppedImageUrl,
                    img: this.state.selectedCroppedImage,
                    height: newHeight,
                    width: newWidth,
                }),

                selectedCroppedImageUrl: null,
                selectedCroppedImage: null,
                selectedOriginalImage: null,
                selectedOriginalImageUrl: null,
                crop: null
                // finalImageHeight: newHeight,
                // finalImageWidth: newWidth
            }, () => {
                // console.log("did set the new height and width", this.state)
            })
            this.setState({
                modifiedImagesThumbnail: this.state.modifiedImagesThumbnail.concat({
                    url: this.state.selectedCroppedImageUrl,
                    img: this.state.selectedCroppedImage,
                    height: 500,
                    width: 500,
                })})
        }

        onImageReject() {
            let { selectedCroppedImageUrl, selectedCroppedImage } = getInitialState();
            this.setState({
                selectedCroppedImageUrl, selectedCroppedImage, imageCropped: false,
                cropDetails: {},

            }
            )


        }

        handleClick() {
            if (!validateInputLength(this.state.artworkInfo.title, 2, 80)) {
                this.props.navigatorStore.openErrorModal("Artwork name must be between 2 to 80 characters");
                return;
            }
            if (validateIfInputHasEmail(this.state.artworkInfo.description)) {
                this.props.navigatorStore.openErrorModal("Story must not contain any email id, phone number or any other contact details");
                return;
            }

            if (validateIfInputHasTenDigits(this.state.artworkInfo.description)) {
                this.props.navigatorStore.openErrorModal("Story must not contain any email id, phone number or any other contact details");
                return;
            }
            // if (!validateIfInputHasUrl(this.state.artworkInfo.description)) {
            //     this.props.navigatorStore.openErrorModal("Story must not contain any email id, phone number or any other contact details");
            //     return;
            // }

            if (this.state.artworkInfo.description && this.state.artworkInfo.description.length > 750) {
                this.props.navigatorStore.openErrorModal("Story can have a maximum of 750 characters");
                return;
            }
            if (!!this.state.artworkInfo.tags && this.state.artworkInfo.tags.length > 120) {
                this.props.navigatorStore.openErrorModal("Tags can have maximum 120 characters.");
                return;
            }
            if (!this.state.artworkInfo.medium) {
                this.props.navigatorStore.openErrorModal("Please mention the medium");
                return;
            }
            if (this.state.selectedCustomMedium && !this.state.artworkInfo.custom_medium) {
                this.props.navigatorStore.openErrorModal("Please mention custom medium");
                return;
            }
            if (!!this.state.artworkInfo.custom_medium && this.state.artworkInfo.custom_medium.length > 80) {
                this.props.navigatorStore.openErrorModal("Custom medium can have maximum 80 characters.");
                return;
            }
            if (!this.state.artworkInfo.base) {
                this.props.navigatorStore.openErrorModal("Please mention the base");
                return;
            }
            if (this.state.selectedCustomBase && !this.state.artworkInfo.custom_base) {
                this.props.navigatorStore.openErrorModal("Please mention custom base");
                return;
            }
            if (!!this.state.artworkInfo.custom_base && this.state.artworkInfo.custom_base.length > 80) {
                this.props.navigatorStore.openErrorModal("Custom base can have maximum 80 characters.");
                return;
            }
            if (!this.state.artworkInfo.year) {
                this.props.navigatorStore.openErrorModal("Please mention the year of creation");
                return;
            }
            if (!this.state.artworkInfo.dimension) {
                this.props.navigatorStore.openErrorModal("Please mention the dimension unit");
                return;
            }
            if (this.state.artworkInfo.width <= 0) {
                this.props.navigatorStore.openErrorModal("Please mention the width");
                return;
            }
            if (this.state.artworkInfo.height <= 0) {
                this.props.navigatorStore.openErrorModal("Please mention the height");
                return;
            }
            // some
            if (this.state.artworkInfo.depth < 0) {
                this.props.navigatorStore.openErrorModal("Depth can not be negative");
                return;
            }
            if (this.state.artworkInfo.width.length > 6 || this.state.artworkInfo.height.length > 6 || this.state.artworkInfo.depth.length > 6) {
                this.props.navigatorStore.openErrorModal("Maximum 6 characters long");
                return;
            }
            if (!!this.state.artworkInfo.created_by && this.state.artworkInfo.created_by.length > 80) {
                this.props.navigatorStore.openErrorModal("Created by name can have maximum 80 characters.");
                return;
            }
            if (!!this.state.artworkInfo.created_by && !validateIfInputHasCharactersAllowSpaces(this.state.artworkInfo.created_by)) {
                this.props.navigatorStore.openErrorModal("Created by name can have maximum 80 characters.");
                return;
            }
            if (!this.state.artworkInfo.self_created && !this.state.artworkInfo.created_by) {
                this.props.navigatorStore.openErrorModal("Please mention the creator's name");
                return;
            }
            if (this.state.artworkInfo.wish_to_sell && !this.state.artworkInfo.currency_code) {
                this.props.navigatorStore.openErrorModal("Please mention currency");
                return;
            }
            if (this.state.artworkInfo.sell_prints && !this.state.artworkInfo.print_price) {
                this.props.navigatorStore.openErrorModal("Please mention the print price");
                return;
            }

            if (this.state.artworkInfo.wish_to_sell && this.state.artworkInfo.seller_price <= 0) {
                this.props.navigatorStore.openErrorModal("Please mention price");
                return;
            }


            // if (!validateInputLength(this.state.artworkInfo.tags, 1)) {
            //     this.props.navigatorStore.openErrorModal("Please mention tags");
            //     return;
            // }


            if (!!this.state.artworkInfo.seller_price && this.state.artworkInfo.seller_price.toString().includes(".")) {
                this.props.navigatorStore.openErrorModal("Price must be an integer.");
                return;
            }




            // console.log("coming here to convert", this.state.artworkInfo.seller_price, this.state.currencyExchangerates)
            if (this.state.artworkInfo.seller_price && !!this.state.artworkInfo.seller_price) {
                // console.log("coming here to convert", this.state.artworkInfo.seller_price, this.state.currencyExchangerates)
                var product_base_price = parseFloat(parseFloat(this.state.artworkInfo.seller_price) + parseFloat(this.state.artworkInfo.seller_price * 0.15));
                // console.log("base_price", product_base_price)
                var usd_price = parseFloat(parseFloat(product_base_price) / (this.state.currencyExchangerates[this.state.artworkInfo.currency_code.toLowerCase()]));
                // console.log("usd_price", usd_price, (this.state.currencyExchangerates[this.state.artworkInfo.currency_code]))
                var sgd_price = parseFloat(parseFloat(usd_price) * parseFloat(this.state.currencyExchangerates.sgd));
                // console.log("sgd_price", sgd_price)
                var inr_price = parseFloat(parseFloat(usd_price) * parseFloat(this.state.currencyExchangerates.inr));
                // console.log("inr_price", inr_price)
                var cny_price = parseFloat(parseFloat(usd_price) * parseFloat(this.state.currencyExchangerates.cny));
                // console.log("cny_price", cny_price)
                var aed_price = parseFloat(parseFloat(usd_price) * parseFloat(this.state.currencyExchangerates.aed));
                // console.log("aed_price", aed_price)
                var eur_price = parseFloat(parseFloat(usd_price) * parseFloat(this.state.currencyExchangerates.eur));
                // console.log("eur_price", eur_price)
                var rub_price = parseFloat(parseFloat(usd_price) * parseFloat(this.state.currencyExchangerates.rub));
                // console.log("rubprice", rub_price)
                var gbp_price = parseFloat(parseFloat(usd_price) * parseFloat(this.state.currencyExchangerates.gbp));
                // console.log("gbpprice", this.state.artworkInfo.height, this.state.artworkInfo.dimension, this.props.generalStore.dimensionConversionRatesToCM[this.state.dimension]);
            }
            var base_height = parseFloat((this.state.artworkInfo.height) * (this.props.generalStore.dimensionConversionRatesToCM[this.state.artworkInfo.dimension]))
            var base_width = parseFloat((this.state.artworkInfo.width) * (this.props.generalStore.dimensionConversionRatesToCM[this.state.artworkInfo.dimension]))
            var base_depth = parseFloat((this.state.artworkInfo.depth) * (this.props.generalStore.dimensionConversionRatesToCM[this.state.artworkInfo.dimension]))

            // console.log("height,width,depth", base_height, base_depth, base_width)
            var formData = new FormData();

            var formData = new FormData();
            formData.append('fb_id', "user._profile.id");

            ReactGA.pageview('/Upload artwork action');

            this.setState({
                artworkInfo: {
                    ...this.state.artworkInfo,
                    // base: baseQuery,
                    // medium: mediumQuery,
                    product_base_price: product_base_price || 0,
                    usd_price: usd_price || 0,
                    sgd_price: sgd_price || 0,
                    inr_price: inr_price || 0,
                    gbp_price: gbp_price || 0,
                    rub_price: rub_price || 0,
                    aed_price: aed_price || 0,
                    eur_price: eur_price || 0,
                    base_depth: Math.round(base_depth * 100) / 100 || 0,
                    base_height: Math.round(base_height * 100) / 100 || 0,
                    base_width: Math.round(base_width * 100) / 100 || 0,
                    depth: Math.round(this.state.artworkInfo.depth * 100) / 100 || 0,
                    height: Math.round(this.state.artworkInfo.height * 100) / 100 || 0,
                    width: Math.round(this.state.artworkInfo.width * 100) / 100 || 0,
                    dimension: this.state.artworkInfo.dimension,
                    medium: this.state.artworkInfo.medium,
                    base: this.state.artworkInfo.base
                }
            },
                function () {

                    // console.log("{medium", this.state.artworkInfo.medium, this.state.artworkInfo.base);

                    (this.state.editMode) ?
                        this.props.artworksStore.updateArtwork(this.state.artwork_id, this.state.artworkInfo)
                            .then((res) => {
                                //console.log(res);
                                ReactGA.pageview('/Edit artwork action');
                                // this.componentDidMount()
                                this.props.artworksStore.getArtworkDetailsPrivate(this.state.artwork_id)
                                    .then((response) => {
                                        // console.log(response)

                                        this.setState({
                                            editedTheArtwork: true,
                                            artworkInfo: {
                                                ...this.state.artworkInfo,
                                                title: response.data[0].title,
                                                description: response.data[0].description,
                                                story: response.data[0].story,
                                                tags: response.data[0].tags,
                                                seller_price: response.data[0].seller_price,
                                                young_artist: response.data[0].young_artist,
                                                product_base_price: response.data[0].product_base_price,
                                                height: response.data[0].height,
                                                width: response.data[0].width,
                                                depth: response.data[0].depth,
                                                base_height: response.data[0].base_height,
                                                base_width: response.data[0].base_width,
                                                base_depth: response.data[0].base_depth,
                                                year: response.data[0].year,
                                                disability: response.data[0].disability,
                                                mature_content: response.data[0].mature_content,
                                                sell_prints: response.data[0].sell_prints,
                                                usd_price: response.data[0].usd_price,
                                                self_created: response.data[0].self_created,
                                                currency_code: response.data[0].currency_code,
                                                medium: response.data[0].medium,
                                                base: response.data[0].base,
                                                created_by: response.data[0].created_by,
                                                print_price: response.data[0].print_price,
                                                wish_to_sell: response.data[0].wish_to_sell,
                                                artworkImg1: response.data[0].img1,
                                                artworkImg2: response.data[0].img2,
                                                artworkImg3: response.data[0].img3,
                                                dimension: response.data[0].dimension,

                                            }
                                        })
                                    })
                            })

                        : this.handleSaveClick()

                }
            )




        }
        // validations = [{key:'modifiedImages', validators:[validateIfInputHasEmail , validateIfInputHasTenDigits]};]

        handleSaveClick() {
            if (this.state.modifiedImages.length == 0) {
                this.props.navigatorStore.openErrorModal("Please choose an image to submit")
                return;
            }
            let _scope = this;
            let firstModifiedImage = _scope.state.modifiedImages[0];
            // console.log("[_scope.state.modifiedImages]", _scope.state.modifiedImages);
            _scope.resizeAndUploadOneImage(firstModifiedImage, true, {
                title: "first image "
            }).then((response) => {
                // console.log("artwork ", response);
                // debugger;
                return response;
                this.setState({
                    artwork_id__ : response
                })
                // }).catch(errorInFirstUpload => {
                //     // console.log("errorInFirstUpload ", errorInFirstUpload);
                //     throw errorInFirstUpload;
            }).then(artWorkId => {
                // debugger;
                let imageProcessPromises = _scope.state.modifiedImages.splice(1).map((fileDetailObj, fIdx) => {
                    return _scope.resizeAndUploadOneImage(fileDetailObj, false, "img" + (fIdx + 2), {
                        artWorkId
                    })
                });
                let imageProcessPromisesThumbnail = _scope.state.modifiedImagesThumbnail.map((fileDetailObj, fIdx) => {
                    console.log("fileDetailObj",fileDetailObj)
                    return _scope.resizeAndUploadOneImage(fileDetailObj, false, "timg" + (fIdx + 1), {
                        artWorkId
                    })
                    
                });
       
                return Promise.all(imageProcessPromises.concat(imageProcessPromisesThumbnail))
                
            }).then(resolutions => {
                // console.log("resolutions = ", resolutions);
                // this.props.navigatorStore.openErrorModal("SUCCESS!!");
                _scope.setState(
                    getInitialState())
                _scope.setState({
                    submittedImages: true
                })
            }).catch(issueInUploading => {
                // console.log(issueInUploading);
                this.props.navigatorStore.openErrorModal("Error Uploading Image, Please try again later ")
            })
            .then(()=>{
                // now uploading thumbnails

                console.log(this.state.artwork_id__,_scope.state.modifiedImagesThumbnail)
             /*    let imageProcessPromisesThumbnail = _scope.state.modifiedImagesThumbnail.map((fileDetailObj, fIdx) => {
                    return _scope.resizeAndUploadOneImage(fileDetailObj, false, "timg" + (fIdx + 1), {
                        artWorkId
                    })
                    
                });
                return Promise.all(imageProcessPromisesThumbnail) */
                
            });
        }

        resizeAndUploadOneImage(fileDetailObj, isFirst, imgKey, imageOptions = false) {
            let _scope = this;

            // console.log("came here for the promise"))
            return new Promise((resolve, reject) => {
                const options = {
                    maxWidth: fileDetailObj.width,
                    maxHeight: fileDetailObj.height,
                }
                const fileReader = new FileReader();
                // // console.log("with width and height", _scope.state.finalImageWidth, _scope.state.finalImageHeight);
                let arrayBuffer;
                fileReader.onload = function (event) {
                    arrayBuffer = event.target.result;
                    resizer(arrayBuffer, options)
                        .then(image => {
                            // image resized
                            const blob = new Blob([image], { type: 'image/png' });
                            image.src = blob;
                            var formData = new FormData();
                            if (isFirst) {
                                formData.append("img1", blob, `img1${localStorage.getItem("profile_id") + Math.random()}.png`);
                                formData.append("product_type", "1");
                                // formData.append("dimension", "1");
                                // formData.append("title", "oneImageMan");
                                for (var key in _scope.state.artworkInfo) {
                                    formData.append(key, _scope.state.artworkInfo[key]);
                                }
                                formData.append("medium", _scope.state.artworkInfo.medium.substring(0, _scope.state.artworkInfo.medium.lastIndexOf(",")));
                                formData.append("base", _scope.state.artworkInfo.base.substring(0, _scope.state.artworkInfo.base.lastIndexOf(",")));
                                _scope.props.artworksStore.createNewArtwork(formData)
                                    .then((res) => {
                                        // console.log(res)
                                        resolve(res.data.id);
                                    }).catch(err => {
                                        reject(err)
                                    })
                            } else {
                                formData.append(imgKey, blob, imgKey + ".png");
                                _scope.props.artworksStore.addArtworkImage(imageOptions.artWorkId, formData, null)
                                    .then((res) => {
                                        // console.log(res)
                                        resolve(true)
                                        // return res.data.id;
                                    }).catch(err => {
                                        reject(err)
                                    })

                            }
                        }).catch(reject)
                };
                fileReader.readAsArrayBuffer(fileDetailObj.img);
            })
        }
        handleCurrencySelection(currencyAbbrevation) {
            // console.log(`Selected ${currencyAbbrevation}`);
            this.setState({
                artworkInfo: { ...this.state.artworkInfo, currency_code: currencyAbbrevation.target.value }
            }, function () {
                // console.log(this.state.artworkInfo.currency_code)
            })
        }
        uploadImagesOnServer() {

            var formData = new FormData();
            formData.append("img1", this.state.finalImages[0], "myFile.png");
            formData.append("img2", this.state.finalImages[1], "myFile.png");
            formData.append("title", "My Art for testing");
            formData.append("product_type", "1");

            this.props.artworksStore.createNewArtwork(formData)
                .then((res) => {
                    // console.log(res)
                })
        }
        handelUploadMoreClick() {
            this.setState(
                getInitialState())
        }



        handelPrivateToggle(item) {
            // console.log("coming here", item)
            switch (item) {
                case ("private_mode"): {
                    this.setState({
                        artworkInfo: {
                            ...this.state.artworkInfo, private_mode: !this.state.artworkInfo.private_mode
                        }
                    }, function () {
                        // !// console.log(this.state.artworkInfo)
                    })
                    break;

                }
                case ("young_artist"): {
                    this.setState({
                        artworkInfo: { ...this.state.artworkInfo, young_artist: !this.state.artworkInfo.young_artist }
                    })
                    break;
                }
                case ("mature_content"): {
                    this.setState({
                        artworkInfo: { ...this.state.artworkInfo, mature_content: !this.state.artworkInfo.mature_content }
                    })
                    break;
                }
                case ("sell_prints"): {
                    this.setState({
                        artworkInfo: { ...this.state.artworkInfo, sell_prints: !this.state.artworkInfo.sell_prints }
                    })
                    break;
                }
                case ("self_created"): {
                    this.setState({
                        artworkInfo: { ...this.state.artworkInfo, self_created: !this.state.artworkInfo.self_created }
                    })
                    break;
                }
                case ("wish_to_sell"): {
                    this.setState({
                        artworkInfo: { ...this.state.artworkInfo, wish_to_sell: !this.state.artworkInfo.wish_to_sell }
                    })
                    break;
                }
                case ("disability"): {
                    this.setState({
                        artworkInfo: { ...this.state.artworkInfo, disability: !this.state.artworkInfo.disability }
                    })
                } break;
            }



        }


        handlePreviewImageDelete(idx) {
            this.setState({
                modifiedImages: this.state.modifiedImages.filter((item, index) => index != idx)
            })
        }

        handleMediumChange = (filterKey) => (selectedOptions, action, a, b, c) => {
            // console.log(selectedOptions, "argument", action);
            if (this.state.editMode) {
                if (!selectedOptions.length) {
                    this.setState({
                        medium: []
                    })
                    return;
                }
                if (action.action == "deselect-option" && action.option.label == "Others") {
                    this.setState({
                        selectedCustomMedium: false
                    })
                }
                {
                    var s1 = selectedOptions.map((el) => `${el.label}`)
                    var s2 = s1.toString()
                    var s3 = s2.replace(/,/g,", ")

                    this.setState({
                        medium: selectedOptions,
                        selectedCustomMedium: s2.includes("Others"),
                        artworkInfo: {
                            ...this.state.artworkInfo,
                            medium: s3
                        }
                    }, () => {
                        // console.log("argument ", s3)
                    })

                }
                return;
            }

           else if (!selectedOptions.length) {
                this.setState({

                    artworkInfo: {
                        ...this.state.artworkInfo,
                        medium: ""
                    }
                })
                if (action.action == "deselect-option" && action.option.label == "Others") {
                    this.setState({
                        selectedCustomMedium: false
                    })
                }
                return;
            }
            else {
                selectedOptions.map((el, idx) => {
                    if (el.label == ("Others")) {
                        this.setState({
                            selectedCustomMedium: true
                        })
                    }

                })
                if (action.action == "deselect-option" && action.option.label == "Others") {
                    this.setState({
                        selectedCustomMedium: false
                    })
                }
                let mediumQuery = `${this.state.artworkInfo.medium}`
                selectedOptions.map((el, idx) => {
                    if (this.state.artworkInfo.medium) {
                        if (!this.state.artworkInfo.medium.includes(el.value)) {
                            mediumQuery = mediumQuery.concat(`${el.value}, `)
                        }
                        // console.log("{mediumQuery}", mediumQuery)
                    }
                    else mediumQuery = mediumQuery.concat(`${el.value}, `)
                })
                // console.log("argument", mediumQuery)
                this.setState({
                    artworkInfo: {
                        ...this.state.artworkInfo,
                        medium: mediumQuery
                    }

                }, function () {
                    // console.log("{mediumQuery}", this.state.artworkInfo.medium)
                })
            }
        }
        handleBaseChange = (filterKey) => (selectedOptions, action, a, b, c) => {
            // console.log(selectedOptions);
            if (this.state.editMode) {
                if (!selectedOptions.length) {
                    this.setState({


                        base: []

                    })
                    return;
                }
                    if (action.action == "deselect-option" && action.option.label == "Others") {
                        this.setState({
                            selectedCustomBase: false
                        })
                    }
                 {
                    var s1 = selectedOptions.map((el) => `${el.label}`)
                    var s2 = s1.toString()
                    var s3 = s2.replace(/,/g,", ")
                    this.setState({
                        base: selectedOptions,
                        selectedCustomBase: s2.includes("Others"),
                        artworkInfo: {
                            ...this.state.artworkInfo,
                            base: s3
                        }
                    }, () => {
                        // console.log("argument ", s2, s3)
                    })

                }
                return;
            }
            if (!selectedOptions.length) {
                this.setState({

                    artworkInfo: {
                        ...this.state.artworkInfo,
                        base: ""
                    }
                })
                if (action.action == "deselect-option" && action.option.label == "Others") {
                    this.setState({
                        selectedCustomBase: false
                    })
                }
                return;
            }
            else {
                selectedOptions.map((el, idx) => {
                    if (el.label == ("Others")) {
                        this.setState({
                            selectedCustomBase: true
                        })
                    }
                })
                if (action.action == "deselect-option" && action.option.label == "Others") {
                    this.setState({
                        selectedCustomBase: false
                    })
                }

                let baseQuery = `${this.state.artworkInfo.base}`
                selectedOptions.map((el, idx) => {
                    if (this.state.artworkInfo.base) {
                        if (!this.state.artworkInfo.base.includes(el.value)) {
                            baseQuery = baseQuery.concat(`${el.value}, `)
                        }
                        // console.log("{mediumQuery}", baseQuery)
                    }
                    else baseQuery = baseQuery.concat(`${el.value}, `)
                })
                // console.log(baseQuery)
                this.setState({
                    artworkInfo: {
                        ...this.state.artworkInfo,
                        base: baseQuery
                    }
                }, function () {
                    // console.log("{mediumQuery}", this.state.artworkInfo.base)
                })
            }
        }
        handleChangeYear(event) {
            // console.log("year", event.target.value);
            this.setState({
                artworkInfo: {
                    ...this.state.artworkInfo,
                    year: event.target.value
                }
            })
        }
        render() {

            const TechniqueOptions = [
                { label: 'Oil', value: "Oil" },
                { label: 'Acrylic', value: "Acrylic" },
                { label: 'Watercolor', value: "Watercolor" },
                { label: 'Charcoal', value: "Charcoal" },
                { label: 'Graphite', value: "Graphite" },
                { label: 'Pencil', value: "Pencil" },
                { label: 'Mixed', value: "Mixed" },
                { label: 'Pastel', value: "Pastel" },
                { label: 'Ink', value: "Ink" },
                { label: 'Others', value: 'Others' },
            ];
            const BaseOptions = [
                { label: 'Canvas', value: "Canvas" },
                { label: 'Stone', value: "Stone" },
                { label: 'Metal', value: "Metal" },
                { label: 'Ceramic', value: "Ceramic" },
                { label: 'Wood', value: "Wood" },
                { label: 'Glass', value: "Glass" },
                { label: 'Clay', value: "Clay" },
                { label: 'Paper', value: "Paper" },
                { label: 'Others', value: 'Others' },
            ];
            const allowAddingMoreImages = this.state.modifiedImages.length < MAX_IMAGES;

            if (this.state.uploadMore) {
                return (
                    <Redirect push to='/uploadimage2'></Redirect>
                )
            }
            if (this.state.editedTheArtwork) {
                return (
                    <Redirect push to={`/profile/details/${localStorage.getItem("username")}`}></Redirect>
                )
            }

            return (
                <div className="back_">
                    {/* CroppingModal  */}
                    <Modal show={this.state.showCropMode} onClose={this.onCloseCrop.bind(this)}>
                        <Modal.Content>
                            <div className="crop-screen-header">
                                <p className="crop-screen-heading">CROP
                            <img onClick={this.onCloseCrop.bind(this)} className="cross-icon-for-modal" src={require('../../../assets/cross_icon_for_close.png')}></img></p>
                            </div>
                            <div className="crop-screen-image">
                                <ReactCrop
                                    src={this.state.selectedOriginalImageUrl}
                                    crop={this.state.cropDetails}
                                    onImageLoaded={this.handleImageLoaded.bind(this)}
                                    onComplete={this.handleOnCropComplete.bind(this)}
                                    onChange={this.handleOnCropChange.bind(this)}
                                />
                            </div>
                            <canvas style={{ display: "none" }} ref={this.imagePreviewCanvasRef}></canvas>
                            <Button className="masterpieces-primary-buttons" id="crop-screen-button"
                                onClick={this.onImageCropDone.bind(this)}><p
                                    style={{ fontFamily: "Montserrat", color: "#FFFFFF" }}>Done</p></Button>
                        </Modal.Content>
                    </Modal>


                    <div className="col-sm-12">
                        <article className="post-88 page type-page status-publish hentry">
                            <div className="woocommerce">
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <div className="heading-welcome_">
                                            {(this.state.editMode) ? "ARTWORK DETAILS" : "NEW ARTWORK"}
                                            <hr className="line-category-name margin-auto"></hr>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 UploadPaintingCard paintingUpload width-65">

                                        <div className="container_">
                                            <p className="basic-details">Basic Details</p>
                                            <div style={{
                                                marginBottom: "5%",
                                                marginTop: "5%",
                                                display: "flex",
                                                justifyContent: "flex-start"
                                            }}>
                                                {/* {this.state.modifiedImages.map((modifiedImage, idx) => (
                                             <div className="image-preview"  >
                                             <button > close </button> // onclose, remove this img from array
                                             <img className="image-preview" src={modifiedImage.url}></img>
                                             </div>
                                             ))}*/}
                                                <div style={{ flex: 3 }} className="image-preview-container">
                                                    {this.state.modifiedImages.map((modifiedImage, imageIdx) => (
                                                        <div style={{ display: this.state.preview }}
                                                            className="image-preview-block">
                                                            <img alt="" className="image-preview"
                                                                src={modifiedImage.url}></img>
                                                            <img alt="" className="image-delete-icon"
                                                                src={imagespath.deleteIcon}
                                                                onClick={() => {
                                                                    this.handlePreviewImageDelete(imageIdx)
                                                                }}></img>
                                                        </div>
                                                    ))}
                                                    <div
                                                        style={{ flex: (MAX_IMAGES - this.state.modifiedImages.length), display: (this.state.editMode) ? "none" : "" }}>    </div>
                                                    <div style={{ display: (this.state.editMode) ? "flex" : "none" }}
                                                        className="image-preview-block" >
                                                        <img style={{ display: (this.state.artworkInfo.artworkImg1) ? "" : "none", flex: 1 }} src={this.state.artworkInfo.artworkImg1} className="image-preview"></img>
                                                        <img style={{ display: (this.state.artworkInfo.artworkImg2) ? "" : "none", flex: 1 }} src={this.state.artworkInfo.artworkImg2} className="image-preview"></img>
                                                        <img style={{ display: (this.state.artworkInfo.artworkImg3) ? "" : "none", flex: 1 }} src={this.state.artworkInfo.artworkImg3} className="image-preview"></img>
                                                    </div>
                                                </div>

                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ display: (allowAddingMoreImages && !this.state.editMode) ? '' : 'none', flex: 1 }}
                                                        className="rectangle-input-file">
                                                        <img alt="" className="big-plus-image-input"
                                                            style={{ display: this.state.inputOneEnable }}
                                                            onClick={(event) => { event.target.value = null }}
                                                            onChange={this.showImage.bind(this)}
                                                            src={imagespath.bigPlus}></img>
                                                        <input style={{ display: this.state.inputOneEnable }}
                                                            className="input-type-file"
                                                            type="file" name="object1"
                                                            onChange={this.showImage.bind(this)}
                                                            onClick={(event) => {
                                                                event.target.value = null
                                                            }}
                                                            accept="image/*"></input>
                                                    </div>
                                                    <div className="content-choose-image"
                                                        style={{
                                                            display: (allowAddingMoreImages && !this.state.editMode) ? '' : 'none',
                                                            flex: 2
                                                        }}>
                                                        <p className="artwork-choose-image-heading">Click to choose
                                                        image {this.state.modifiedImages.length + 1}
                                                            {` `}
                                                            of {` `}{MAX_IMAGES}</p>
                                                        <p className="artwork-choose-image-content">You can upload a maximum of 3 images, with the first image showing the front view of the artwork.
                                                    </p>
                                                        <p className="artwork-choose-image-request">The first image should be of the complete front view of the artwork. You can upload different angles of the same artwork in the 2nd and 3rd images..</p>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="basic-details-form">

                                                <div className="form-group">
                                                    <label htmlFor="address1">Artwork Name</label>
                                                    <input value={this.state.artworkInfo.title}
                                                        onChange={this.handleInputTextChange.bind(this)} type="text"
                                                        name="title" required placeholder="Title of your artwork. E.g. Mona Lisa"
                                                        className="form-element-small-input">
                                                    </input>
                                                </div>


                                                <div className="form-group">
                                                    <label htmlFor="address1">ARTWORK STORY</label>
                                                    <textarea value={this.state.artworkInfo.description}
                                                        onChange={this.handleInputTextChange.bind(this)}
                                                        name="description"
                                                        placeholder="Write a story/description to attract your audience E.g. I was inspired by my mother to make this painting (optional)"
                                                        required className="form-element-large-input">
                                                    </textarea>
                                                </div>


                                                <div className="form-group">
                                                    <label htmlFor="address1">Artwork Tags</label>
                                                    <input value={this.state.artworkInfo.tags}
                                                        onChange={this.handleInputTextChange.bind(this)} type="text"
                                                        name="tags" required placeholder="List any tags related to your artwork E.g. watercolour, sunset, colourful (optional)"
                                                        className="form-element-small-input">
                                                    </input>
                                                </div>
                                            </div>

                                            <div className="basic-details-form">
                                                <p className="form-section-name mb-15">TECHNIQUE</p>
                                                <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>

                                                    <div className="col-md-12 pl-0 pr-0">
                                                        <div className="form-group pb-15">
                                                            <label htmlFor="Technique">MEDIUM</label>
                                                   {   this.state.editMode ?    
                                                         <ReactMultiSelectCheckboxes
                                                          placeholderButtonLabel={this.state.artworkInfo.medium && this.state.artworkInfo.medium || "Select medium"}
                                                                value={(this.state.editMode) ? this.state.medium : this.state.artworkInfo.medium}
                                                                onChange={this.handleMediumChange(TechniqueOptions.key)}
                                                                options={this.state.mediumChoices} /> :
                                                         <ReactMultiSelectCheckboxes 
                                                         placeholderButtonLabel={this.state.artworkInfo.medium && this.state.artworkInfo.medium || "Select medium"}
                                                                // value={this.state.medium}
                                                                onChange={this.handleMediumChange(TechniqueOptions.key)}
                                                                options={this.state.mediumChoices} />
                                                    }
                                                        </div>
                                                    </div>


                                                    <div className="col-md-12 pl-0 pr-0">
                                                        <div style={{
                                                            flex: 1,
                                                            display: (this.state.selectedCustomMedium) ? "" : "none"
                                                        }} className="form-group pb-15">
                                                            <label htmlFor="address1">CUSTOM MEDIUM</label>
                                                            <input
                                                                value={this.state.artworkInfo.custom_medium}
                                                                onChange={this.handleInputTextChange.bind(this)} type="text" name="custom_medium" required placeholder="E.g. Electrocanvas plating"
                                                                className="form-element-small-input">
                                                            </input>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                                                    <div className="col-md-12 pl-0 pr-0">
                                                        <div className="form-group pb-15">
                                                            <label htmlFor="Technique">Base</label>
                                                    {       
                                                        this.state.editMode ? 
                                                        <ReactMultiSelectCheckboxes
                                                                placeholderButtonLabel={this.state.artworkInfo.base && this.state.artworkInfo.base || "Select base"}
                                                                value={(this.state.editMode) ? this.state.base : this.state.artworkInfo.base}
                                                                onChange={this.handleBaseChange(BaseOptions.key)}
                                                                options={this.state.baseChoices} /> :
                                                                <ReactMultiSelectCheckboxes
                                                                placeholderButtonLabel={this.state.artworkInfo.base && this.state.artworkInfo.base || "Select base"}
                                                                // value={(this.state.editMode) ? this.state.base : this.state.artworkInfo.base}
                                                                onChange={this.handleBaseChange(BaseOptions.key)}
                                                                options={this.state.baseChoices} />
                                                    }
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 pl-0 pr-0">
                                                        <div style={{ flex: 1, display: (this.state.selectedCustomBase) ? "" : "none" }} className="form-group">
                                                            <label htmlFor="address1">CUSTOM BASE</label>
                                                            <input
                                                                value={this.state.artworkInfo.custom_base}
                                                                onChange={this.handleInputTextChange.bind(this)} type="text" name="custom_base" required placeholder="E.g. Fabric"
                                                                className="form-element-small-input">
                                                            </input>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="basic-details-form">
                                                    <p className="form-section-name mt-15 mb-15">Specifications</p>


                                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <div className="col-md-12 pl-0 pr-0">
                                                            <div className="form-group">
                                                                <label htmlFor="address1">YEAR OF CREATION</label>
                                                                <select value={this.state.artworkInfo.year} onChange={this.handleChangeYear.bind(this)}>
                                                                    <option></option>
                                                                    {
                                                                        years.map((year, index) => {
                                                                            return (

                                                                                <option key={`year${index}`} value={year}>{year}</option>

                                                                            )
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                            <div style={{ flex: 1 }} >
                                                                <div className="form-group pb-15">
                                                                    <label htmlFor="Technique">Dimension Unit</label>
                                                                    <select placeholder="E.g. Inches"
                                                                        value={this.state.artworkInfo.dimension}
                                                                        onChange={this.handleDimensionChange.bind(this)}
                                                                        name="dimension" className="form-control"
                                                                        id="sel1">
                                                                        <option style={{ display: "none" }}></option>
                                                                        <option value="CENTIMETERS">CENTIMETERS</option>
                                                                        <option value="METERS">METERS</option>
                                                                        <option value="INCHES" >INCHES</option>
                                                                        <option value="FEET">FEET</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-15">

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="address1">WIDTH{this.state.dimensionUnit}</label>
                                                            <input value={this.state.artworkInfo.width} onChange={this.handleInputTextChange.bind(this)} type="number" min="0" step="0.01" required name="width"
                                                                className="form-element-small-input"
                                                                placeholder="E.g. 24">

                                                            </input>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="address1">HEIGHT{this.state.dimensionUnit}</label>
                                                            <input value={this.state.artworkInfo.height} onChange={this.handleInputTextChange.bind(this)} type="number" min="0" step="0.01" required name="height"
                                                                className="form-element-small-input" placeholder="E.g. 38">
                                                            </input>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="address1">DEPTH{this.state.dimensionUnit}</label>
                                                            <input value={this.state.artworkInfo.depth} type="number" onChange={this.handleInputTextChange.bind(this)} step="0.01" min="0" required name="depth"
                                                                className="form-element-small-input" placeholder="E.g. 2">
                                                            </input>
                                                        </div>
                                                    </div>


                                                </div>


                                                <div className="basic-details-form mb-15">
                                                    <p className="form-section-name mt-15">Artwork settings</p>

                                                    {/* <div className="form-element inline-sale">
                                                    <p className="available-for-sale ">Make Artwork Private
                                                    <p className="artwork-choose-image-request">(FREE TRIAL)</p>
                                                    </p>
                                                    <div className="toggle-button">
                                                        <div onClick={() => this.handelPrivateToggle("private_mode")}
                                                            className="toggle-button-box">
                                                            <div className="toggle-button-oval" style={{
                                                                float: (this.state.artworkInfo.private_mode) ? "right" : "left",
                                                                backgroundColor: (this.state.artworkInfo.private_mode) ? "#BEA57C" : "#BDBDBD"
                                                            }}>
                                                            </div>
                                                        </div >
                                                    </div>
                                                </div>
                                                <div style={{
                                                    flex: 1,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    marginBottom: "2%",
                                                    display: (this.state.artworkInfo.private_mode) ? "" : "none"
                                                }}
                                                    className="terms-and-conditions-section">
                                                    <div className="listTerms">
                                                        <p className="terms-and-conditions">
                                                            You can now mark your artworks as private. Users can send you requests to view these artworks and you can choose to accept or decline the request.
                                                    </p>

                                                    </div>
                                                </div> */}

                                                    <div className="form-element inline-sale">
                                                        <p className="available-for-sale ">Mature content</p>
                                                        <div className="toggle-button">
                                                            <div onClick={() => this.handelPrivateToggle("mature_content")}
                                                                className="toggle-button-box">
                                                                <div className="toggle-button-oval" style={{
                                                                    float: (this.state.artworkInfo.mature_content) ? "right" : "left",
                                                                    backgroundColor: (this.state.artworkInfo.mature_content) ? "#BEA57C" : "#BDBDBD"
                                                                }}>
                                                                </div>
                                                            </div >
                                                        </div>
                                                    </div>
                                                    <div style={{
                                                        flex: 1,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        marginBottom: "2%",
                                                        // display: (this.state.artworkInfo.mature_content) ? "" : "none"
                                                    }}
                                                        className="terms-and-conditions-section">
                                                        <div className="listTerms">
                                                            <p className="terms-and-conditions">
                                                                Does this work include nudity, blood, guns, alcohol, drugs, violence, adult language and other similar content that may be considered not suitable for minors?
                                                    </p>

                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="basic-details-form mb-15">
                                                    <p className="form-section-name mt-15">Creator details</p>
                                                    <div className="form-element inline-sale">
                                                        <p className="toggle-section-name label-text-form">Created by me</p>
                                                        <div className="toggle-button">
                                                            <div onClick={() => this.handelPrivateToggle("self_created")}
                                                                className="toggle-button-box">
                                                                <div className="toggle-button-oval" style={{
                                                                    float: (this.state.artworkInfo.self_created) ? "right" : "left",
                                                                    backgroundColor: (this.state.artworkInfo.self_created) ? "#BEA57C" : "#BDBDBD"
                                                                }}>
                                                                </div>
                                                            </div >
                                                        </div>

                                                    </div>
                                                    <div style={{
                                                        flex: 1,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        marginBottom: "2%",
                                                        display: (!this.state.artworkInfo.self_created) ? "" : "none"
                                                    }}
                                                        className="terms-and-conditions-section">
                                                        <div className="form-group pt-15">
                                                            <label htmlFor="address1 label-text-form">CREATOR NAME</label>
                                                            <input value={this.state.artworkInfo.created_by} type="text" step="1"
                                                                style={{ marginBottom: "0%" }}
                                                                onChange={this.handleInputTextChange.bind(this)}
                                                                name="created_by" required placeholder="Vincent Luggers"
                                                                className="form-element-small-input">
                                                            </input>
                                                        </div>
                                                    </div>


                                                    <div className="form-element inline-sale">
                                                        <p className="toggle-section-name label-text-form">Artist is below 12 Years of age</p>
                                                        <div className="toggle-button">
                                                            <div onClick={() => this.handelPrivateToggle("young_artist")}
                                                                className="toggle-button-box">
                                                                <div className="toggle-button-oval" style={{
                                                                    float: (this.state.artworkInfo.young_artist) ? "right" : "left",
                                                                    backgroundColor: (this.state.artworkInfo.young_artist) ? "#BEA57C" : "#BDBDBD"
                                                                }}>
                                                                </div>
                                                            </div >
                                                        </div>

                                                    </div>
                                                    {/* <div className="form-element inline-sale">
                                             <p className="toggle-section-name">Artist is a student</p>
                                             <div className="toggle-button">
                                             <div onClick={() => this.handelPrivateToggle("student")}
                                             className="toggle-button-box">
                                             <div className="toggle-button-oval" style={{
                                             float: this.state.positionSaleToggleOval,
                                             backgroundColor: this.state.colorSaleToggleOval
                                             }}>
                                             </div>
                                             </div >
                                             </div >
                                             </div> */}

                                                    <div className="form-element inline-sale">
                                                        <p className="toggle-section-name label-text-form ">Artist is specially
                                                    abled</p>
                                                        <div className="toggle-button">
                                                            <div onClick={() => this.handelPrivateToggle("disability")}
                                                                className="toggle-button-box">
                                                                <div className="toggle-button-oval" style={{
                                                                    float: (this.state.artworkInfo.disability) ? "right" : "left",
                                                                    backgroundColor: (this.state.artworkInfo.disability) ? "#BEA57C" : "#BDBDBD"
                                                                }}>
                                                                </div>
                                                            </div >
                                                        </div>
                                                    </div>
                                                    <div className="listTerms">
                                                            <p className="terms-and-conditions">
                                                            Does the creator of this artwork have any mental or physical disabilities?
                                                    </p>

                                                        </div>
                                                </div>
                                                <div className="basic-details-form">
                                                    <p className="form-section-name mt-15">Sales Information</p>
                                                    <div className="form-element inline-sale">
                                                        <p className="available-for-sale">Available for sale</p>
                                                        <div className="toggle-button">
                                                            <div onClick={() => this.handelPrivateToggle("wish_to_sell")}
                                                                className="toggle-button-box">
                                                                <div className="toggle-button-oval" style={{
                                                                    float: (this.state.artworkInfo.wish_to_sell) ? "right" : "left",
                                                                    backgroundColor: (this.state.artworkInfo.wish_to_sell) ? "#BEA57C" : "#BDBDBD"
                                                                }}>
                                                                </div>
                                                            </div >
                                                        </div >
                                                    </div>


                                                    <div className="row pt-15" style={{ display: this.state.artworkInfo.wish_to_sell ? "" : "none" }}>

                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="address1">CURRENCY</label>
                                                                <select value={this.state.artworkInfo.currency_code} onChange={this.handleCurrencySelection.bind(this)} className="form-element-small-input ml-0 mr-0" >
                                                                    <option style={{ display: "none" }}></option>
                                                                    {
                                                                        this.props.generalStore.Currencies.map((el, idx) =>
                                                                            <option value={el.key}>{el.display}</option>
                                                                        )
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="form-group">

                                                                <label htmlFor="address1">PRICE</label>
                                                                <input value={this.state.artworkInfo.seller_price} type="number" min="1" onChange={this.handleInputTextChange.bind(this)}
                                                                    className="form-element-small-input" name="seller_price" step="1"
                                                                    placeholder="10,000">

                                                                </input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="basic-details-form mb-15"></div>
                                                <div className="form-element inline-sale">
                                                    <p className="available-for-sale">Sell Prints</p>
                                                    <div className="toggle-button">
                                                        <div onClick={() => this.handelPrivateToggle("sell_prints")}
                                                            className="toggle-button-box">
                                                            <div className="toggle-button-oval" style={{
                                                                float: (this.state.artworkInfo.sell_prints) ? "right" : "left",
                                                                backgroundColor: (this.state.artworkInfo.sell_prints) ? "#BEA57C" : "#BDBDBD"
                                                            }}>
                                                            </div>
                                                        </div >
                                                    </div>
                                                </div>
                                                <div className="listTerms">
                                                            <p className="terms-and-conditions">
                                                            We are coming soon with the feature to buy prints on YourMasterpieces. If you wish to sell prints of your original artwork, enter price for the print. Please note, artist gets the full price quoted for each sale of this print. Printing, framing and/or shipping cost should be excluded from this price.
                                                    </p>

                                                        </div>
                                                <div style={{
                                                        flex: 1,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        marginBottom: "2%",
                                                        display: (!this.state.artworkInfo.sell_prints) ? "none" : ""
                                                    }}
                                                        className="terms-and-conditions-section">
                                                        <div className="form-group pt-15">
                                                            <label htmlFor="address1 label-text-form">PRINT PRICE</label>
                                                            <input value={this.state.artworkInfo.print_price} type="integer" step="1"
                                                                style={{ marginBottom: "0%" }}
                                                                onChange={this.handleInputTextChange.bind(this)}
                                                                name="print_price" required placeholder="123"
                                                                className="form-element-small-input">
                                                            </input>
                                                        </div>
                                                    </div>
                                                {/* <div className="row" style={{ display: (this.state.artworkInfo.sell_prints) ? "" : "none" }}>

                                             <div className="col-md-6">
                                             <div className="form-group">
                                             <label htmlFor="address1">SALES EMAIL</label>
                                             <input type="number" placeholder="sale@picasso.com"
                                             className="form-element-small-input">

                                             </input>
                                             </div>
                                             </div>

                                             <div className="col-md-6">
                                             <div className="form-group">

                                             <label htmlFor="address1">PHONE WITH COUNTRY CODE</label>
                                             <input type="number" placeholder="(021) 329-9288"
                                             className="form-element-small-input">

                                             </input>
                                             </div>
                                             </div>
                                             </div> */}

                                                <div>
                                                    <Button onClick={this.handleClick.bind(this)}
                                                        className="masterpieces-primary-buttons btn-primary"
                                                        id="save-details-btn">{(this.state.editMode) ? `SAVE DETAILS` : `PUBLISH ARTWORK`}
                                                    </Button>
                                                </div>
                                                {/* <div>
                                             <Button onClick={this.handleSaveClick.bind(this)}
                                             className="masterpieces-primary-buttons btn-primary"
                                             id="save-details-btn">SAVE
                                             DETAILS</Button>
                                             </div> */}
                                                <div>
                                                    <Modal show={this.state.submittedImages}
                                                        onClose={this.close.bind(this)} {...this.props.modal}
                                                        className="crop-screen-modal">
                                                        {this.props.children}
                                                        <Modal.Content>
                                                            <div className="terms-and-conds-header no-min-height">
                                                                <p className="terms-and-conds-heading pt-15 pb-15">Artwork
                                                                    Uploaded
                                                                <img onClick={this.close.bind(this)} className="cross-icon-for-modal" src={require('../../../assets/cross_icon_for_close.png')}></img></p>
                                                            </div>
                                                            <div className="masterpieces-modal-content">
                                                                <div className="terms-and-conds-content ">

                                                                    <div className="important-instructions">
                                                                        <img alt=""
                                                                            className="terms-and-conds-upload-icon"
                                                                            src={uploadedArtIconBig}></img>
                                                                        <div
                                                                            className="terms-and-conds-important-instructions">
                                                                            <h1 className="terms-and-conds-important-instructions-heading">
                                                                                You have successfully uploaded your
                                                                                artwork
                                                                        </h1>

                                                                        </div>
                                                                    </div>
                                                                    <div className="upload-artwork-photos"
                                                                        style={{ marginTop: "2%" }}>
                                                                        <div className="upload-artwork-photos-heading">
                                                                            What happens next?
                                                                    </div>
                                                                        <li className=" upload-artwork-photos-content">
                                                                            When a buyer requests to buy the painting,
                                                                            we send you an email
                                                                            to conform the availability of your artwork,
                                                                            please always keep
                                                                            your details updated with us.
    
                                                                    </li>
                                                                        <li className=" upload-artwork-photos-content">
                                                                            In case the painting is sold out by other
                                                                            means, please let the
                                                                            masterpieces team know about the same to
                                                                            avoid any inconvinience
                                                                            to the buyer.
                                                                    </li>
                                                                        <li className=" upload-artwork-photos-content">
                                                                            You will need to update the dispatch date
                                                                            and your convenient
                                                                            time less than 20days from your order
                                                                            confirmation
                                                                    </li>
                                                                        <li className=" upload-artwork-photos-content">
                                                                            Please ensure the artwork is kept ready to
                                                                            be dispatched before
                                                                            5 hours from the given time.
                                                                    </li>
                                                                        <li className="upload-artwork-photos-content pb-25">
                                                                            You will receive m-credits once the buyer
                                                                            completes payment and
                                                                            will be transferred to your bank account on
                                                                            successful delivery
                                                                            of the artwork and customer satisfaction.
                                                                    </li>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="masterpieces-modal-footer  pb-25 height56">
                                                                <div style={{
                                                                    marginLeft: "5%",
                                                                    display: "flex",
                                                                    flex: 1,
                                                                    marginTop: "15px"
                                                                }}>

                                                                    <div className="agreement-text">
                                                                        Keep a check of your spam folder and add us to
                                                                        yor contacts
                                                                </div>
                                                                </div>
                                                                <Button onClick={this.handelUploadMoreClick.bind(this)}
                                                                    className="masterpieces-primary-buttons"
                                                                    id="continue-button">
                                                                    <p style={{ color: "#FFFFFF" }}>UPLOAD MORE</p>
                                                                </Button>
                                                            </div>
                                                        </Modal.Content>
                                                    </Modal>
                                                </div>
                                            </div>
                                        </div>
                                    </div >
                                </div>
                            </div>
                        </article>
                    </div>
                </div >

            )
        }
    }


// WEBPACK FOOTER //
// ./src/components/Home/profile/uploadImageReplacement.js